import React from 'react'
import { formatteDate } from '../../../services/common'

const renderConfig = {
    date: (value) => `Publié le ${formatteDate(value)}`,
}

const Attributes = ({ attributes }) => {
    const renderAttributes = () => {
        return Object.entries(attributes).map(([key, value]) => {
            const renderFunction = renderConfig[key]
            return renderFunction ? <p className="baseocom-small">{renderFunction(value)}</p> : null
        })
    }

    return renderAttributes()
}

export default Attributes
